import React, { useEffect, useState } from "react";
import { string_to_slug } from "../../store/utility";
import SimpleRating from "../UI/Rating/SimpleRating";
import classes from "./ProductCard.module.css";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
const ProductCard = (props) => {
  const [wishlist, setWishlist] = useState([]);
  const [isExists, setExist] = useState({});
  const product = props.product;
  let slug = string_to_slug(product.productTitle);
  let productThumbnail = null;
  if (product.variable) {
    productThumbnail = product.variants[0].previewImages[0];
  } else {
    //productThumbnail = product.productImgUrl;
    productThumbnail = product.previewImages[0];
  }
  const getProductPrice = () => {
    try {
      let price = "";
      if (product.variable) {
        let regularPrice = [];
        let salePrice = [];
        product.variants.map((pr) => {
          regularPrice.push(pr.regularPrice);
          salePrice.push(pr.salePrice);
        });
        salePrice = salePrice.sort();
        regularPrice = regularPrice.sort();

        if (!salePrice.length) {
          return <label>""</label>;
        }

        if (salePrice.length == 1) {
          price = (
            <>
              <label>
                Rs.{salePrice[0]} &nbsp;&nbsp;{" "}
                <span style={{ textDecoration: "line-through" }}>
                  Rs.{regularPrice[0]}
                </span>
              </label>
              <label
                className="badge  badge-danger"
                style={{ height: "fit-content" }}
              >
                {Math.round((1 - salePrice[0] / regularPrice[0]) * 100)} % Off
              </label>
            </>
          );
        } else {
          price = (
            <>
              <label>
                Rs.{salePrice[0]} - Rs.{salePrice[salePrice.length - 1]}
              </label>
              <label
                className="badge  badge-danger"
                style={{ height: "fit-content" }}
              >
                {Math.round((1 - salePrice[0] / regularPrice[0]) * 100)} % Off
              </label>
            </>
          );
        }
      } else {
        price = (
          <>
            <label>
              Rs.{product.salePrice} &nbsp;&nbsp;{" "}
              <span style={{ textDecoration: "line-through" }}>
                Rs.{product.regularPrice}
              </span>
            </label>
            <span
              className="badge  badge-danger"
              style={{ height: "fit-content" }}
            >
              {Math.round((1 - product.salePrice / product.regularPrice) * 100)}{" "}
              % Off
            </span>
          </>
        );
      }
      return price;
    } catch (error) {
      return <label>""</label>;
    }
  };

  useEffect(() => {
    try {
      setWishlist(props.wishlist);
      // if(props.wishlist.includes(product.id)){
      //     // setExist({...isExists,[product.id]:true})
      //     // console.log("Remove")
      // }else{
      //     // console.log("Add")
      //     // setExist({...isExists,[product.id]:false})
      // }
    } catch (error) {}
  }, [props.wishlist]);

  useEffect(() => {
    try {
      if (props.wishlistproducts) {
        props.wishlistproducts.map((w) => {
          document.getElementById(`wishlisticon${w.id}`).className =
            "fa fa-heart";
        });
      }
    } catch (error) {}
  }, [props.wishlistproducts]);

  useEffect(() => {
    if (props.isUser) {
      props.onFetchWishlist(props.userId);
    }
  }, [props.userId]);

  const handleAddToWishlist = () => {
    props
      .onAddToWishlist(props.userId, product.id)
      .then((response) => {
        setWishlist(response);
      })
      .catch((err) => {});
  };

  const getWish = (productId) => {
    let wishc = null;
    if (wishlist.includes(productId)) {
      // console.log("REmove Wish")
      wishc = (
        <i
          className="fa fa-heart"
          aria-hidden="true"
          onClick={() => props.onRemoveFromWishlist(props.userId, product.id)}
        ></i>
      );
    } else {
      console.log("Add Wish");
      wishc = (
        <i
          className="fa fa-heart-o"
          aria-hidden="true"
          onClick={() => handleAddToWishlist()}
        ></i>
      );
      // wishc = <i className="fa fa-bandcamp" aria-hidden="true" onClick={()=>handleAddToWishlist()}></i>
    }
    return wishc;
  };
  const handleWishlist = (productId) => {
    let userId = props.userId;

    if (wishlist.includes(productId)) {
      // console.log("Remove")
      props
        .onRemoveFromWishlist(userId, productId)
        .then((response) => {
          setWishlist(response);
          document.getElementById(`wishlisticon${productId}`).className =
            "fa fa-heart-o";
        })
        .catch((err) => {});
    } else {
      // console.log("Add")
      props
        .onAddToWishlist(userId, productId)
        .then((response) => {
          setWishlist(response);
          document.getElementById(`wishlisticon${productId}`).className =
            "fa fa-heart";
        })
        .catch((err) => {});
    }
  };
  return (
    <div className={classes.ProductCard}>
      {/* <label style={{float:"left"}}>Trending</label> */}
      {props.isUser && (
        <div style={{ float: "right", fontSize: "17px", cursor: "pointer" }}>
          {
            // wishlist&&wishlist.includes(product.id)?(
            //     <i className="fa fa-heart" aria-hidden="true"
            //     onClick={()=> props.onRemoveFromWishlist( props.userId,product.id) }></i>
            // ):(
            //     <i className="fa fa-heart-o" aria-hidden="true"  onClick={()=>handleAddToWishlist()}></i>
            // )
            // isExists[product.id]? <i className="fa fa-heart" aria-hidden="true"
            // onClick={()=> props.onRemoveFromWishlist( props.userId,product.id) }></i>:
            // <i className="fa fa-bandcamp" aria-hidden="true" onClick={()=>handleAddToWishlist()}></i>
            <i
              className={`fa ${
                wishlist.includes(product.id) ? "fa-heart" : "fa-heart-o"
              }`}
              aria-hidden="true"
              onClick={() => handleWishlist(product.id)}
              id={`wishlisticon${product.id}`}
            ></i>
            // getWish(product.id)
          }
        </div>
      )}

      <a href={`/product/${slug}/${product.id}`} target="_blank">
        {" "}
        <img src={productThumbnail} className={classes.ProductImage} />{" "}
      </a>

      <div>
        <a href={`/product/${slug}/${product.id}`} target="_blank">
          <p>{product.productTitle}</p>
        </a>
      </div>

      <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        {product.rating && (
          <SimpleRating
            rating={product.rating}
            key={Math.random() * 10000}
            readOnly={"readOnly"}
            // onPostRating={()=>this.props.onPostReview(order.receipt,order.rating,null)}
          />
        )}
        {product.reviewCount && (
          <label>
            ({product.reviewCount}{" "}
            {product.reviewCount > 1 ? "reviews" : "review"})
          </label>
        )}
      </div>
      <div style={{ display: "flex", justifyContent: "space-evenly" }}>
        {product.variable}
        {/* <label>Rs.4,599 - Rs.5,349</label>
                <label>35% off</label> */}
        {getProductPrice()}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isUser: !state.auth.admin && !state.auth.staff,
    wishlist: state.account.wishlist,
    user: state.auth.user,
    userId: state.auth.userId,
    wishlistproducts: state.account.wishlistproducts,
  };
};
const mapDisptachToProps = (dispatch) => {
  return {
    onAddToWishlist: (userId, productId) =>
      dispatch(actions.onAddToWishlist(userId, productId)),
    onRemoveFromWishlist: (userId, productId) =>
      dispatch(actions.onRemoveFromWishlist(userId, productId)),
    onFetchWishlist: (userId) => dispatch(actions.onFecthWishlist(userId)),
  };
};
export default connect(mapStateToProps, mapDisptachToProps)(ProductCard);
